import SDKIntegrationsHelper from '../../../../Utility/SDK/SDKIntegrationsHelper';
import GameStateHelper from '../../../Game/GameStateHelper';
import { ContextType } from '../../../Game/IContext';
import { IGameState } from '../../../Game/IGameState';

export function helperFriendRequest(state: IGameState, friendId: string) {
    SDKIntegrationsHelper.helperFriendRequest(friendId);
    return GameStateHelper.setContext(state, ContextType.REQUEST_HELP, {});
}
